import { Navigate } from 'react-router-dom';
import i18n from '@/lib/i18n/i18n';
import Cookies from 'js-cookie';

export default function LocaleRedirect() {
    const cookieLng = Cookies.get('i18next');
    const lng = (cookieLng || i18n.language || 'ar').split('-')[0];
    const locale = lng === 'en' ? 'en' : 'ar';
    return <Navigate to={`/${locale}`} replace />;
}
